import React from 'react';

import Layout from '../components/Layout';

const Privacy = () => {
	return (
		<Layout>
			<div className='privacy'>
				<h1>Privacy Policy</h1>
				<p>
					This Privacy Policy describes the information collected by the mobile
					device application PetGeo («PetGeo», «Us», «We»), how that information
					may be used, with whom it may be shared, and Your choices about such
					uses and disclosures. The App PetGeo is owned by YUNA Solution, TOO
					based in Almaty Kazakhstan. By using the PetGeo App (the «App») and
					the services, features, content, applications or widgets, as well as
					mobile device applications offered by YUNA Solution, TOO, You are
					accepting the practices described in this Privacy Policy. This Policy
					forms an integral part of our Terms of Use that is incorporated by
					reference. Any capitalised term used but not defined in this Policy
					will have the meaning defined in the Terms of Use Agreement. The
					Information PetGeo may collect
					<br />
					<br />
					1. Information You Provide
					<br />
					<br />
					PetGeo may, in the future, collect and store any personal information.
					You enter through the Services or the App. This may include personally
					identifying information, such as Your name, residence, e-mail address
					or gender. PetGeo may also request information about Your interests
					and activities, location, Your username and Your Pet’s information,
					including dietary and nutritional habits. We will use Your information
					only in accordance with the terms of our privacy policies.
					Unfortunately no system can be completely secure. Therefore, PetGeo
					does not promise, and You should not expect, that such information may
					not be inadvertently collected and that such personal information will
					remain secure.
					<br />
					<br />
					2. Information Collected Automatically
					<br />
					<br />
					Like many apps or sites on the Internet, the App automatically
					collects information from Your browser when You visit the App. WhenYou
					use PetGeo’s mobile application, PetGeo may collect various
					non-identifying information, such as Your mobile device type, device
					properties, IP address, profile views, ad views, ad clicks, search
					queries, photo views, and page views. We may also combine all of this
					non-identifying information with other non-identifying information to
					infer interests or demographic characteristics. In order for PetGeo to
					work with Your iPhone, iPod touch, iPad, BlackBerry, or other mobile
					device, PetGeo must collect Your Open Device Identification Number or
					«ODIN». The ODIN is a special type of identifier used in software
					applications in order to provide a unique reference number for
					applications like those used by Your mobile device. Your ODIN is not
					shared with other users.
					<br />
					<br />
					3. Cookies and Use of Cookie Data
					<br />
					<br />
					When You use PetGeo’s mobile device applications, PetGeo may use
					mobile cookies. A mobile cookie is a small data file transferred to
					Your mobile device for record-keeping purposes. These mobile cookies
					help PetGeo track session-based information and also better understand
					the effectiveness of the Services. These mobile cookies do not contain
					any personally identifiable information.
					<br />
					<br />
					4. Information Collected by Third Parties
					<br />
					<br />
					PetGeo may allow third parties, advertising companies, and ad networks
					to display advertisements on the App and via the Services. These
					companies may use tracking technologies, such as cookies, to collect
					information about users who view or interact with their
					advertisements.
					<br />
					<br />
					5. Agents
					<br />
					<br />
					Should PetGeo employ or engage other companies and individuals to
					perform business functions on behalf of the App and Services, these
					persons may be provided personal identifying information required to
					perform their functions. They are prohibited by contract from using
					the information for other purposes. These persons engage in a variety
					of functions which include, but are not limited to, fulfilling orders,
					removing repetitive information from user lists, analyzing data,
					providing marketing assistance, and providing user services.
					<br />
					<br />
					6. How PetGeo Uses the Information It Collects
					<br />
					<br />
					PetGeo may use information that it collects as described above to:
					Deliver the services thatYou have requested. Provide You with customer
					support. Enforce or exercise any rights in PetGeo’s Terms of Use.
					Perform functions as otherwise described to You at the time of
					collection.
					<br />
					<br />
					7. Third-Party Websites
					<br />
					<br />
					There may be a number of places on the Site and the Services where You
					may click on a link to access other websites that do not operate under
					this Privacy Policy. These third party websites may independently
					solicit and collect information, including personal information, from
					You. PetGeo recommends that You consult the privacy statements of all
					third party websites You visit by clicking on the «privacy» link,
					typically located at the bottom of the webpage You visit.
					<br />
					<br />
					8. Visiting the App and Services From Outside Kazakhstan
					<br />
					<br />
					This Privacy Policy is intended to cover collection of information on
					the Services from residents of Kazakhstan. If You are visiting the App
					or using the Services from outside Kazakhstan, please be aware that
					Your information may be transferred to, stored, and processed in
					PetGeo’s servers and PetGeo’s central database is operated. By using
					the App or Service, You understand that Your information may be
					transferred to PetGeo’s facilities and those third parties with whom
					PetGeo shares it as described in this Privacy Policy. You are
					responsible for ensuring that information You share conforms to all
					local data protection laws.
					<br />
					<br />
					9. Changes to the Privacy Policy
					<br />
					<br />
					PetGeo will occasionally update this Privacy Policy. When PetGeo posts
					changes to this Privacy Policy, it will revise the date at the top of
					this Privacy Policy. PetGeo recommends that You check the Site from
					time to time to inform Yourself of any changes in this Privacy Policy
					or any of PetGeo’s other policies.
				</p>

				<h1>Terms and Conditions</h1>

				<p>
					Welcome to the PetGeo mobile device application. The PetGeo App is
					owned by YUNA Solution, TOO, based in Almaty Kazakhstan. Please read
					these terms of use carefully before using the services offered by
					PetGeo («PetGeo,» «Us,» or «We»). These terms of use set forth the
					terms and conditions of our relationship and for the user’s («User,»
					«You» or «Your») use of the PetGeo App and the services, features,
					content, mobile device applications, apps, or widgets offered by
					PetGeo (collectively, the «Services»).
					<br />
					<br />
					The Agreement between PetGeo and You
					<br />
					By accessing PetGeo mobile device application, You agree to be bound
					by the terms of this Agreement
					<br />
					1. You understand that by using the App and Services, You are agreeing
					to comply with and be bound by the terms and conditions contained
					herein («Terms of Use» or «Agreement»), which also incorporate PetGeo
					Privacy Policy («Privacy Policy»).
					<br />
					2. This Agreement constitutes the entire and only agreement between
					PetGeo and You.
					<br />
					3. This Agreement supersedes all prior or contemporaneous agreements,
					representations, warranties and understandings with respect to the App
					and the Services, the content, products or services provided by or
					through the App and the Services, and the subject matter of this
					Agreement.
					<br />
					<br />
					You are responsible for reviewing changes to this Agreement
					<br />
					<br />
					1. This Agreement applies to all users of the App and the services.
					<br />
					2. PetGeo may make changes to this Agreement from time to time without
					specifically notifying You.
					<br />
					3. PetGeo will post the latest Agreement on PetGeo’ s mobile device
					applications, but it is up to You to review it before using the App or
					Services.
					<br />
					4. If You continue to use the App or Services after any of these
					changes, Your continued use will mean that You have accepted any
					changes to the Agreement.
					<br />
					5. In addition, some services offered through the App and the Services
					may be subject to additional terms and conditions specified by PetGeo
					from time to time, and Your use of such services is subject to those
					additional terms and conditions, which are incorporated into this
					Agreement by this reference.
					<br />
					<br />
					Your Use of the App and Services
					<br />
					<br />
					Your registration and account security
					<br />
					<br />
					When You use the App or the Services You may provide PetGeo certain
					registration and account information, which PetGeo will rely on to
					provide You its products and services. The following are Your
					obligations when creating, registering, and maintaining the security
					and accuracy of Your account:
					<br />
					1. You will not provide false or misleading information when You
					register an account.
					<br />
					2. If PetGeo terminates or disables Your account, You may not create
					another account without first getting PetGeo’ written consent.
					<br />
					3. You will keep Your contact and other information requested by
					PetGeo accurate and up-to-date.
					<br />
					4. You will not share Your password, let anyone other than You access
					Your account, or do anything that might compromise the security of
					Your account.
					<br />
					5. If You select a username for Your account, PetGeo reserves the
					right to remove or reclaim it if PetGeo, in its sole discretion,
					determines it is inappropriate or for any other reason.
					<br />
					<br />
					Provisions applicable to PetGeo software
					<br />
					<br />
					1. If You download or use any PetGeo software, You agree that from
					time to time, the software may by updated and/or upgraded with
					additional features by PetGeo.
					<br />
					2. You agree to not modify, create derivative works of, decompile or
					otherwise attempt to extract source code from any PetGeo software.
					<br />
					<br />
					Your use of Paid Services
					<br />
					<br />
					If You use and/or subscribe to any of PetGeo’s services that require
					the payment of fees (these services are referred to as «Paid
					Services»), You agree to be bound by the following terms in addition
					to other terms in these terms of use:
					<br />
					<br />
					1. You agree to furnish payment for all applicable fees and any taxes
					or additional charges that may be imposed by third parties.
					<br />
					2. You understand that Your purchases of any of the Paid Services are
					final and non-refundable and that a refund will only be granted if
					PetGeo, in its sole discretion, provides written consent for a refund.
					<br />
					3. You understand that PetGeo may change pricing and fees for any of
					the Paid Services at any time.
					<br />
					4. You understand that PetGeo may, in its sole discretion, modify the
					features and functions of or eliminate any of the Paid Services.
					<br />
					5. You understand that Your use of any of the Paid Services are
					subject to limited licenses provided by PetGeo for You to use the Paid
					Services and that any terms such as «assign, transfer, sell, buy,
					purchase» or any similar terms do not create any actual transfers to
					You of any ownership, right, or title, in any fashion.
					<br />
					6. You understand that You may not resell, transfer, exchange, or
					license the Paid Services to any third parties.
					<br />
					7. You understand that if PetGeo terminates or disables Your account
					that may result in Your license to any Paid Services being terminated
					as well.
					<br />
					<br />
					Your use of bonus awarding charity membership
					<br />
					<br />
					1. Bonus awarding system is an integral part of the App.
					<br />
					2. VETC are being bonuses of the membership and are not the equivalent
					of any currency.
					<br />
					3. PetGeo provides bonuses and writes off bonuses in accordance with
					its bonus system
					<br />
					4. Bonuses can only be used as part of the loyalty program
					<br />
					5. Petgeo reserves the right to change the values in accrual and
					write-off of bonuses within bonus awarding membership without notice
					user.
					<br />
					<br />
					PetGeo may edit or modify anything on the App or Services without
					notice.
					<br />
					<br />
					PetGeo is committed to delivering a positive user experience, and You
					understand that PetGeo reserves the right (but without undertaking any
					duty) to edit, monitor, review, delete, modify, or move any content or
					material provided or placed on or though the App and the Services in
					its sole discretion, without notice.
					<br />
					<br />
					You are responsible for accepting updated versions of the App and
					Services
					<br />
					<br />
					1. If PetGeo provides updated versions of the App and Services and You
					do not accept these updated versions, You may not enjoy the most
					recent content, feature sets, and materials.
					<br />
					2. If You do not accept updated versions of the App and Services,
					PetGeo shall not bear any responsibility or liability for Your
					decision.
					<br />
					<br />
					You agree to let us collect information about Your activity on the App
					and Services
					<br />
					<br />
					1. Because PetGeo wants to continue to improve the App and the
					Services for the benefit of You, the user, We may collect information
					about Your activity on PetGeo mobile device applications and Services.
					<br />
					2. By using any PetGeo mobile device application or the Services You
					specifically agree to allow PetGeo to collect information in this
					manner.
					<br />
					3. You understand, however, that PetGeo cannot and does not make any
					warranties or guarantees that: (i) any PetGeo mobile device
					applications or the Services, or any component thereof or any
					component of the Services, will be made free from error or inaccuracy
					as a result of such monitoring or free from unauthorized and/or
					unacceptable use as a result of such monitoring; (ii) any statements
					or factual items presented by the Services will be free from error or
					authenticated; or (iii) PetGeo will take any action in the event of
					any non-compliance with these terms of use.
					<br />
					4.The PetGeo map and geoposition service is not used for user tracking
					purposes. The PetGeo map is used solely to display relevant tags being
					posted by users.
					<br />
					<br />
					It is Your responsibility to make sure this Agreement and Your use of
					the App and Services complies with all laws applicable to You
					<br />
					<br />
					1. You understand PetGeo may, in its sole discretion, refuse to offer
					the App or the Services to any person or entity and change its
					eligibility criteria at any time.
					<br />
					2. You are solely responsible for ensuring that this Agreement
					complies with all laws, rules and regulations applicable to You.
					<br />
					3. You understand that Your right to access the App or Services will
					be revoked where this Agreement or use of the App or the Services is
					prohibited and, if that is the case, You agree not to use or access
					the App or the Services in any way.
					<br />
					<br />
					Your use of the App and/or Services can end without reason or notice
					to You
					<br />
					<br />
					While PetGeo respects its users, You agree that PetGeo may terminate
					Your membership or use of the App and/or the Services and prohibit You
					from accessing the App and/or the Services, for any reason, or no
					reason, and with or without notice.
					<br />
					<br />
					Who Owns What and How You Can Use It The copyright to all content on
					the App and Services is owned by YUNA Solution, TOO in Kazakhstan.
					<br />
					<br />
					1. The content, organization, graphics, design, compilation, magnetic
					translation, digital conversion and other matters related to the App
					and the Services («Copyright Content») are the property of YUNA
					Solution, TOO and are protected under applicable copyrights,
					trademarks and other proprietary rights.
					<br />
					2. You may not copy, redistribute, use or publish any part of the App
					or the Services, except as allowed by this Agreement.
					<br />
					3. You do not acquire ownership rights to any content, document or
					other materials viewed through the App or the Services.
					<br />
					<br />
					You may not use trademarks appearing on the App or Services in an
					infringing manner
					<br />
					<br />
					1. You agree that «PetGeo» trademark and PetGeo graphics, logos, page
					headers, button icons, scripts, token name and service names are
					trademarks, registered trademarks or trade dress of PetGeo or its
					affiliates («Trademark Content»).
					<br />
					2. Trademark Content may not be used in connection with any product or
					service that is not PetGeo’s, in any manner that is likely to cause
					confusion among customers, or in any manner that disparages or
					discredits PetGeo.
					<br />
					3. All other trademarks not owned by PetGeo or its affiliates that may
					appear on this App or the Services are the property of their
					respective owners, who may or may not be affiliated with, connected
					to, or sponsored by PetGeo or its affiliates.
					<br />
					<br />
					You may use the PetGeo App and Services for limited, noncommercial
					purposes and grant PetGeo limited rights to your content
					<br />
					<br />
					1. PetGeo grants You a limited license to access and make personal use
					of the App and the Services.
					<br />
					2. PetGeo does not grant You the right to modify the App and the
					Services, or any portion of the App and the Services.
					<br />
					3. You understand PetGeo does not grant You the right to resell or
					make commercial use (except as provided herein) of the App and the
					Services or their contents; make any derivative use of the App and the
					Services or their contents; any downloading or copying of account
					information for the benefit of a third party, or merchant; or any use
					of data mining, robots, or similar data gathering and extraction
					tools.
					<br />
					4. You understand the App and the Services or any portion of the App
					and the Services may not be reproduced, duplicated, copied, sold,
					resold, visited, or otherwise exploited for any commercial purpose.
					<br />
					5. You may not frame or utilize framing techniques to enclose any
					trademark, logo, or other proprietary information of PetGeo and our
					affiliates without express written consent.
					<br />
					6. You may not use any meta tags or any other «hidden text» utilizing
					PetGeo’s name or trademarks without the express written consent of
					PetGeo. Any unauthorized use terminates the permission or license
					granted by PetGeo.
					<br />
					7. You may not engage in the copying, reproduction, publication,
					rearrangement, redistribution, modification, revision, alteration, or
					reverse engineering, of the Services.
					<br />
					8. You are granted a limited, revocable, and nonexclusive right to
					create a hyperlink to the home page of PetGeo so long as the link does
					not portray PetGeo, its affiliates, or their products or services in a
					false, misleading, derogatory, or otherwise offensive matter.
					<br />
					9. You may not use any PetGeo logo or other proprietary graphic or
					trademark as part of the link without express written permission.
					<br />
					10. PetGeo does not claim ownership of the content you upload or post
					on or through the App and/or Services. You hereby grant to PetGeo a
					free of charge and royalty-free; non-exclusive; transferable;
					sub-licensable; perpetual; and worldwide license to use such content.
					<br />
					<br />
					What Laws and Rules You Are Responsible For Following
					<br />
					<br />
					You promise to comply with this Agreement and any laws or regulations
					applicable to You
					<br />
					<br />
					1. You promise not to use the App or the Services for any purpose that
					is prohibited by this Agreement.
					<br />
					2. You are responsible for all of Your activity in connection with the
					App and the Services.
					<br />
					3. You shall abide by all applicable local, state, national and
					international laws and regulations and, if You represent a business,
					any advertising, marketing, privacy, or other self-regulatory code(s)
					applicable to You.
					<br />
					<br />
					You agree to comply with PetGeo’s conduct policies when using the App
					or Services
					<br />
					<br />
					We do our best to keep the App and the Services safe and operational,
					but We cannot guarantee it. We need Your help to do that, which
					includes the following commitments:
					<br />
					<br />
					1. You will not modify, adapt, appropriate, reproduce, distribute,
					translate, create derivative works or adaptations of, publicly
					display, republish, repurpose, sell, trade, or in any way exploit the
					Services or App except as expressly authorized by PetGeo;
					<br />
					2. You will not take any action that imposes or may impose (as
					determined by PetGeo in its sole discretion) an unreasonable or
					disproportionately large load on PetGeo’s (or its third party
					providers’) infrastructure;
					<br />
					3. You will not decipher, decompile, disassemble, reverse engineer or
					otherwise attempt to derive any source code or underlying ideas or
					algorithms of any part of the Services, except to the limited extent
					applicable laws specifically prohibit such restriction;
					<br />
					4. You will not interfere or attempt to interfere with the proper
					working of the App and Services or any activities conducted on the App
					and Services;
					<br />
					5. You will not bypass any measures PetGeo may use to prevent or
					restrict access to the App and Services (or other accounts, computer
					systems or networks connected to the App and Services);
					<br />
					6. You will not run any form of auto-responder or «spam» on the App
					and Services;
					<br />
					7. You will not use manual or automated software, devices, or other
					processes to «crawl» or «spider» any page of the App;
					<br />
					8. You will not harvest or scrape any content or materials from the
					App and Services;
					<br />
					9. You will not copy, rent, lease, distribute, or otherwise transfer
					any of the rights that You receive hereunder;
					<br />
					10. You will not threaten, intimidate or harass another user;
					<br />
					11. You will not solicit passwords or personally identifying
					information (this includes, but is not limited to, someone else’s
					name, birth date, home address, IP address, social security number, or
					credit card number) for commercial or unlawful purposes;
					<br />
					12. You will not upload, post, transmit, share, store or otherwise
					make available any material that contains software viruses or any
					other computer code, files or programs designed to interrupt, destroy
					or limit the functionality of any computer software or hardware or
					telecommunications equipment;
					<br />
					13. You will not upload, post, transmit, share, store or otherwise
					make available any content (such as a picture on a profile page) other
					than those of a personal nature that: (i) are of You or Your pets,
					(ii) are taken by You, or (iii) are original content created by You;
					<br />
					14. You will not otherwise take any action in violation of PetGeo’s
					guidelines and policies.
					<br />
					<br />
					Warnings
					<br />
					<br />
					You use the PetGeo App and Services at Your own risk
					<br />
					<br />
					1. PetGeo has no obligation to review any content or material,
					including computer software, posted to or through the App and the
					Services, and can therefore not be responsible for such material or
					content.
					<br />
					2. By operating the App and the Services, PetGeo does not represent or
					imply that it endorses any content or material posted there, or that
					it believes such material to be accurate, useful or non- harmful.
					<br />
					3. You are responsible for taking precautions as necessary to protect
					Yourself and Your computer systems from viruses, worms, Trojan horses,
					and other harmful or destructive content.
					<br />
					4. The App or the Services may contain content that is offensive,
					indecent, or otherwise objectionable, as well as content containing
					technical inaccuracies, typographical mistakes, and other errors.
					<br />
					5. The App or the Services may also contain material that violates the
					privacy or publicity rights, or infringes the intellectual property
					and other proprietary rights, of third parties, or the downloading,
					copying or use of which is subject to additional terms and conditions,
					stated or unstated.
					<br />
					6. PetGeo disclaims any responsibility for any harm resulting from the
					use by visitors of the App or the Services, or from viewing or
					downloading by those visitors of content posted on the App or the
					Services.
					<br />
					<br />
					You are responsible for Your own conduct
					<br />
					<br />
					1. You are solely responsible for Your interactions with other users.
					<br />
					2. PetGeo shall not be liable for any damages whatsoever arising out
					of or relating to the conduct of You or anyone else in connection with
					the use of the Services, including without limitation, bodily injury,
					emotional distress, and/or any other damages resulting from
					communications or meetings with other users or members of the App or
					Services, or persons You meet through the App or Services.
					<br />
					<br />
					PetGeo is not responsible for what happens outside of the App and
					Services, including on websites the App or Services link to or
					advertise
					<br />
					<br />
					1. PetGeo or its business partners may present advertisements or
					promotional materials via the Services.
					<br />
					2. You agree that PetGeo is not responsible or liable for any loss or
					damage of any sort incurred as the result of any such dealings or as
					the result of the presence of such third parties via the Services.
					<br />
					3. You understand the App and the Services may contain (or You may
					receive from PetGeo, third parties or users) links to other web sites
					(«Third Party Sites») or content posted, owned or originating from
					third parties such as, by way of example only, pictures, designs,
					photographs, graphics, text, sound, recipes, video, information,
					software, applications and any other content («Third Party Content»).
					<br />
					4. You understand and agree that PetGeo is not responsible for, and
					does not control, Third Party Sites and Third Party Content. You also
					understand and agree that PetGeo is not responsible for the
					availability of such external sites or resources, and does not endorse
					and is not responsible or liable for any content, advertising,
					products or other materials on or available from such Third Party
					Sites and Third Party Content.
					<br />
					5. You acknowledge and agree that PetGeo shall not be responsible or
					liable, directly or indirectly, for any damage or loss caused or
					alleged to be caused by or in connection with the use of, or reliance
					upon, any such content, goods or services available on or through any
					such Third Party Site or Third Party Content.
					<br />
					<br />
					Information and press releases may not be updated
					<br />
					<br />
					The App and the Services contain information and press releases about
					Us. While this information was believed to be accurate as of the date
					prepared, We disclaim any duty or obligation to update this
					information or any press releases. Information about companies other
					than ours contained in the press release or otherwise, should not be
					relied upon as being provided or endorsed by Us.
					<br />
					<br />
					Legal Conditions
					<br />
					<br />
					PetGeo’ liability is limited
					<br />
					<br />
					1. PetGeo is not responsible for any Third Party Sites, Third Party
					Content, or any other content posted on the App and the Services,
					whether caused by users of the App and the Services, PetGeo, third
					parties or by any of the equipment or programming associated with or
					utilized in the App and the Services.
					<br />
					2. PetGeo is not responsible for the conduct, whether online or
					offline, of any user of the App or the Services.
					<br />
					3. PetGeo assumes no responsibility for any error, omission,
					interruption, deletion, defect, delay in operation or transmission,
					communications line failure, theft or destruction or unauthorized
					access to, or alteration of, user communications.
					<br />
					4. PetGeo is not responsible for any problems or technical malfunction
					of any telephone network or lines, cellular data provider or network,
					computer online systems, servers or providers, computer equipment,
					software, failure of email or players on account of technical problems
					or traffic congestion on the Services or App, including injury or
					damage to users or to any other person’s computer, and/or mobile
					device.
					<br />
					5. Neither PetGeo nor any of its affiliates, advertisers, promoters or
					distribution partners shall be responsible for any loss or damage,
					including personal injury or death, resulting from anyone’s use of the
					App or the Services, any content posted on the App or the Services or
					transmitted to users, or any interactions between users of the App or
					the Services, whether online or offline.
					<br />
					<br />
					WE TRY TO KEEP THE APP AND SERVICES UP, BUG-FREE, AND SAFE, BUT YOU
					USE IT AT YOUR OWN RISK. THE INFORMATION FROM OR THROUGH THE APP AND
					THE SERVICES IS PROVIDED «AS IS,» «AS AVAILABLE,» AND ALL WARRANTIES,
					EXPRESS OR IMPLIED, ARE DISCLAIMED. THE INFORMATION, SITE AND THE
					SERVICES MAY CONTAIN VIRUSES, BUGS, ERRORS, PROBLEMS OR OTHER
					LIMITATIONS. IN NO EVENT WILL PETGEO OR ITS DIRECTORS, EMPLOYEES OR
					AGENTS HAVE ANY LIABILITY WHATSOEVER FOR YOUR USE OF ANY INFORMATION
					OR SERVICE, OR THE APP WE ARE NOT LIABLE FOR ANY INDIRECT, SPECIAL,
					INCIDENTAL OR CONSEQUENTIAL DAMAGES (INCLUDING DAMAGES FOR LOSS OF
					BUSINESS, LOSS OF PROFITS, LITIGATION, OR THE LIKE), WHETHER BASED ON
					BREACH OF CONTRACT, BREACH OF WARRANTY, TORT (INCLUDING NEGLIGENCE),
					PRODUCT LIABILITY OR OTHERWISE, EVEN IF ADVISED OF THE POSSIBILITY OF
					SUCH DAMAGES. NO ADVICE OR INFORMATION OBTAINED BY YOU FROM US THROUGH
					THE SITE/ SERVICE SHALL CREATE ANY WARRANTY, REPRESENTATION OR
					GUARANTEE NOT EXPRESSLY STATED IN THIS AGREEMENT.
					<br />
					<br />
					You agree to indemnify PetGeo
					<br />
					<br />
					You agree to indemnify, defend, and hold harmless PetGeo, its
					contractors, licensors, subsidiaries and affiliates and their
					respective partners, directors, officers, employees and agents from
					and against any and all claims and expenses, including any and all
					losses, costs, liabilities, and attorneys’ fees, arising out of or in
					connection with: (1) Your use of the App and Services, (2) any user
					Content, Third Party Content, Third Party Sites and any other content,
					(3) Your violation of this Agreement, or of any law or the rights of
					any third party, and (4) Your breach of this Agreement and/or any
					breach of Your representations and warranties set forth herein.
					<br />
					<br />
					You agree that Law of Kazakhstan applies to this Agreement
					<br />
					<br />
					Subject to the arbitration clauses included below, if there is any
					dispute arising out of the App and the Services, by using the App, You
					expressly agree that any such dispute shall be governed by the laws of
					Kazakhstan, without regard to its conflict of law provisions, and You
					expressly agree and consent to the exclusive jurisdiction and venue of
					the arbirtation court in Almaty, Kazakhstan, for the resolution of any
					such dispute.
					<br />
					<br />
					Your general representation and warranty
					<br />
					<br />
					You represent and warrant that:
					<br />
					<br />
					1. You will use the App and Services in accordance with the Privacy
					Policy, with this Agreement and with all applicable laws and
					regulations (including without limitation any local laws or
					regulations in Your country, city, or other governmental area,
					regarding online conduct and acceptable content, and including all
					applicable laws regarding the transmission of technical data exported
					from Kazakhstan or the country in which You reside)
					<br />
					2. You will use the App and the Services so not to infringe or
					misappropriate the intellectual property rights of any third party.
					<br />
					<br />
					No relationship with Apple Inc. or Google, Inc.
					<br />
					<br />
					1. You understand that PetGeo is not affiliated with Apple, Inc. or
					Google, Inc.
					<br />
					2. You understand that by using or accessing the Services through
					devices made by Apple, Inc. («Apple») or any devices using the Android
					operating system by Google («Google»):
					<br />— This Agreement is between PetGeo and You only and that neither
					Apple nor Google are parties to this Agreement.
					<br />— Google and Apple and their subsidiaries are third party
					beneficiaries of this Agreement and may have the right to enforce this
					Agreement against You.
					<br />— Nothing contained herein shall impose upon Google or Apple any
					obligation to furnish any maintenance services or support services in
					connection with the Services or in any other way whatsoever in
					connection with the functionality (or lack thereof) or content of the
					Services.
					<br />— Apple nor Google shall assume any responsibility nor liability
					for addressing any claims by You or a third party relating to the
					Services or Your use of the Services.
					<br />
					<br />
					PetGeo’s handling of Intellectual Property
					<br />
					<br />
					As PetGeo asks others to respect its intellectual property rights, it
					respects the intellectual property rights of others. If you believe
					that material located on the App and/or Services violates your
					copyright, you are encouraged to notify PetGeo as described below.
					When PetGeo receives proper Notification of Alleged Copyright
					Infringement as described below, we will promptly remove or disable
					access to the allegedly infringing material and terminate the accounts
					of repeat infringers.
					<br />
					<br />
					Notification of Alleged Copyright Infringement («Notification»):
					<br />
					If you believe that your own copyrighted work is accessible on the
					PetGeo App or service in violation of your copyright, you may provide
					Us with a written communication.
					<br />
					<br />
					Your Notification of Alleged Copyright Infringement must contain
					substantially the following information:
					<br />
					<br />
					i. Identify in detail the copyrighted work or intellectual property
					that you claim has been infringed (e.g. sending URL address to a site
					containing your work). If multiple copyrighted works at a single
					online site are covered by your Notification, you may provide a
					representative list of such works at that site.
					<br />
					ii. Identify the URL or other specific location on the PetGeo App
					and/or Services that contains the material that you claim infringes
					your copyright. You must provide us with reasonably sufficient
					information to locate the alleged infringing material.
					<br />
					iii. Provide the electronic or physical signature of the owner of the
					copyright or a person authorized to act on the owner’s behalf.
					<br />
					iv. Include a statement by you that you have a good faith belief that
					the disputed use is not authorized by the copyright owner, its agent,
					or the law.
					<br />
					v. Include a statement by you that the information contained in your
					Notice is accurate and that you attest under the penalty of perjury
					that you are the copyright owner or that you are authorized to act on
					the copyright owner’s behalf.
					<br />
					vi. Include your name, mailing address, telephone number and email
					address.
					<br />
					<br />
					You may submit your Notification by sending it to YUNA Solution, TOO
					Almaty Kazakhstan, by E-Mail as set forth below:
					<br />
					<br />
					<a
						href='mailto:develop@petgeo.org'
						target='_blank'
						rel='noopener noreferrer'
						className='privacy__email'
					>
						develop@petgeo.org
					</a>
					<br />
					<br />
					1. Filing a false form on this page constitutes perjury. Please note
					that you may be liable for damages, including court costs and
					attorney’s fees, if you materially misrepresent that content on our
					application and/or service is copyright infringing.
					<br />
					2. Upon receiving a proper Notification as described above, we will
					remove or disable access to the allegedly infringing material and
					promptly notify the alleged infringer of your claim.
				</p>
			</div>
		</Layout>
	);
};

export default Privacy;
